import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Inject,
  OnDestroy,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';
import {CdkVirtualScrollViewport} from '@angular/cdk/scrolling';
import {Subscription} from 'rxjs';
import {PANEL_DATA} from '../../../../commons/angular/services/panel.service';
import {ButtonSizeType} from '../../../../commons/types/button-size.type';
import {ServicePointModel} from '../../models/service-point.model';
import {ServicePointsComponentStore} from '../../state/service-points-component.store';
import {getServicePointLabel} from '../../utils/service-point-display.util';
import * as angular from 'angular';

interface ServicePointSelectListModel {
  selectedId?: string;
  ngPlaceholder?: string;
  buttonSize?: ButtonSizeType;
}

require('./service-point-select-list.scss');
@Component({
  standalone: false,
  selector: 'app-service-point-select-list',
  templateUrl: './service-point-select-list.html',
  providers: [ServicePointsComponentStore],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ServicePointSelectListComponent implements OnInit, OnDestroy {

  @Output() onClose = new EventEmitter<{servicePoint: ServicePointModel | null}>();

  @ViewChild(CdkVirtualScrollViewport, {static: false})
  private cdkVirtualScrollViewport: CdkVirtualScrollViewport;

  public ngPlaceholder: string;
  public queryString: string = '';
  public loadLimit: number = 20;
  public servicePoints: ServicePointModel[] = [];
  public selectedServicePoint: ServicePointModel | null;
  public servicePointsSubscription: Subscription;
  public cursor: string;
  public isLoading: boolean;
  public buttonSize: ButtonSizeType;

  constructor(@Inject(PANEL_DATA) public data: ServicePointSelectListModel,
                @Inject(ChangeDetectorRef) private cdr: ChangeDetectorRef,
                @Inject(ServicePointsComponentStore) private servicePointsStore: ServicePointsComponentStore) {
  }

  ngOnInit() {
    this.ngPlaceholder = this.data.ngPlaceholder;
    this.buttonSize = this.data.buttonSize;

    this.servicePointsSubscription = this.servicePointsStore.vm$.subscribe((vm) => {
      this.cursor = vm.cursor;
      this.isLoading = vm.loading;
      this.servicePoints = vm.servicePoints;
      if (this.data.selectedId && !this.selectedServicePoint) {
        this.selectedServicePoint = vm.servicePoints.find(sp => sp.id === this.data.selectedId) || null;
      }
      this.cdkVirtualScrollViewport?.checkViewportSize();
      this.cdr.detectChanges();
    });

    this._getServicePoints();
  }

  ngOnDestroy() {
    if (this.servicePointsSubscription) {
      this.servicePointsSubscription.unsubscribe();
    }
  }

  getNextBatch() {
    if (this.cdkVirtualScrollViewport.measureScrollOffset('bottom') < 150 && this.cursor && !this.isLoading) {
      this._getServicePoints();
    }
  }

  onToggle(servicePoint: ServicePointModel) {
    this.selectedServicePoint = angular.copy(servicePoint);
  }

  onSubmit() {
    this.onClose.emit({servicePoint: this.selectedServicePoint});
  }

  onReset() {
    this.onClose.emit({servicePoint: null});
  }

  onCancel() {
    this.onClose.emit({servicePoint: this.selectedServicePoint});
  }

  onQueryChange(query) {
    this.queryString = query;
    this._resetStore();
    this._getServicePoints();
  }

  getListLabel(servicePoint: ServicePointModel): string {
    return getServicePointLabel(servicePoint);
  }

  private _resetStore() {
    this.servicePointsStore.resetServicePoints();
  }

  private _getServicePoints() {
    this.servicePointsStore.getServicePoints({
      limit: this.loadLimit,
      query: this.queryString,
      sort: 'name,asc'
    });
  }
}
